module.exports = __webpack_public_path__ + "static/media/fazhan.479c5a8e.png";